module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAMCom",
    attrs: {
      "id": "BAMCom"
    }
  }, [_c('v-BAMSide', {
    attrs: {
      "userInfo": _vm.userInfo
    }
  }), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "articleList": _vm.articleList,
      "userInfo": _vm.userInfo,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "getCategories": _vm.getCategories,
      "getWordCount": _vm.getWordCount,
      "clearArticleList": _vm.clearArticleList,
      "showMessage": _vm.showMessage
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "articleList": _vm.articleList,
      "userInfo": _vm.userInfo,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "getCategories": _vm.getCategories,
      "getWordCount": _vm.getWordCount,
      "clearArticleList": _vm.clearArticleList,
      "showMessage": _vm.showMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793400db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/BAM/layout.vue
// module id = 278
// module chunks = 1